export default __webpack_public_path__ + "static/media/13.e257fcf4.png";